module.exports = __webpack_public_path__ + "static/img/23-business-admin.0c4b179.png";


//////////////////
// WEBPACK FOOTER
// ./static/Icon/23-business-admin.png
// module id = PeyX
// module chunks = 1